import auction_adding from "./auction-adding";
import enums from "./enums";
import generals from "./generals";
import infoIcons from "./infoIcons";
import ramps from "./ramps";
import ratings from "./ratings";
import routes from "./routes";
import tableDetails from "./tableData";
import tutorial from "./tutorial";
import verificationPayment from "./verificationPayment";
import widgets from "./widgets";

export default {
  enums: enums,
  verificationPayment: verificationPayment,
  tutorial: tutorial,
  auth: {
    register_title_button: "Click here to register",
    dont_have_account: "Don't have an account?",
    forgot_password_label: "Forgot password?",
    remember_me_label: "Stay signed in",
    log_in_label: "Log in",
    password_label: "Password",
    enter_password_placeholder: "Enter password",
    enter_email_placeholder: "Enter email",
    enter_login_or_email_label: "Enter username or email",
    error_wrong_login_or_password: "Incorrect username or password",
    log_in_progress_label: "Logging in...",
    server_error_short: "Server error",
    server_error_try_again: "Internal server error. Please try again later.",
    email_is_required: "Email address is required",
    password_is_required: "Password is required",
    user_not_verified: "The account has not been verified. A verification link has been sent to the email address provided during registration.",
    wrong_password: "Wrong password.",
    regulations_acceptance_first: "I have read the Privacy Policy",
    regulations_acceptance_second: "I have read the Terms of Use",
    regulationsAcceptance: "You must accept the Terms of Use",
    privacyAcceptance: "You must accept the Privacy Policy",
    gus: "Fill in the company details based on the Tax ID.",
    gus_correct: "Match found. Show GUS data",
    gus_incorrect: "No match. Show GUS data",
    workers: "XLplanner employees",
    same_passwords: "The current and new passwords must be different",
  },
  register: {
    select_country: "Select a country",
    select_country_description: "Select the country where your company is registered",
    choose_account_type_to_go_further: "You must select an account type to continue",
    confirming_e_mail_has_been_sent: "The confirmation email has been sent again!",
    message: "Message content",
    inviteCompany: "Send invitation to XLplanner",
    inviteCompanyShort: "Send invitation",
    addWorker: "Add employee",
    role: "Role",
    admin: "Administrator",
    worker: "Employee",
    account_type: "Account type",
    typeToChange: "Change account type to:",
    empty_account_type_placeholder: "No account type",
    company_data: "Company data",
    user_data: "User data",
    pick_type: "Select account type",
    enter_company_data: "Enter company data",
    enter_user_data: "Enter user data",
    company: "Company name",
    address_placeholder: "Enter company address",
    city: "City",
    city_placeholder: "Enter city",
    country: "Country",
    country_placeholder: "Enter country name",
    zipCode: "Postal code",
    zipCode_placeholder: "Enter postal code",
    nip_placeholder: "Enter tax number",
    company_placeholder: "Enter company name",
    address: "Company address",
    zip_code: "Postal code",
    nip: "Tax number",
    email: "Email",
    email_placeholder: "Enter email",
    name: "First name",
    name_placeholder: "Enter first name",
    phone: "Phone number",
    appellation: "Name",
    phone_placeholder: "Enter phone number",
    surname: "Last name",
    surname_placeholder: "Enter last name",
    user_role: "I am",
    password: "Password",
    password_placeholder: "Enter password",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Confirm password",
    regulations_acceptance_first: "I accept the terms of the",
    regulations_acceptance_second: "Terms of Use",
    regulations_acceptance_third: "and the",
    regulations_acceptance_fourth: "Privacy Policy.",
    personal_data_processing_agreement: "I agree to the storage of my personal data",
    other_processing_agreement:
      "As part of the services provided in this agreement, PayPro makes available to the Merchant an additional mechanism allowing the collection of payer data (first name, last name, address, IBAN) based on a verification transfer (GeTPayerInfo). The personal data referred to in the previous sentence may only be made available after obtaining the payer's voluntary consent and may only be processed by the Merchant for the purpose and to the extent specified in this consent. The content of such consent is point 1 of this appendix:",
    other_processing_agreement2:
      "1. 'I consent to the transfer of my personal data by the data controller PayPro SA, based in Poznań (60-198), Pastelowa Street 8, to ANOTHER INVEST Sp. z o.o., which originate from the payment transaction I made via PayPro SA, for the purpose of conducting my verification by ANOTHER INVEST Sp. z o.o., including anti-fraud analysis. The data transfer includes: first and last name, address, IBAN number. Consent is voluntary, but its absence may require a verification transfer from the customer's bank account. This consent may be withdrawn at any time; however, withdrawal does not affect the legality of processing prior to withdrawal.'",
    cancel: "Cancel",
    create_account: "Create account",
    creating_account_in_progress: "Creating account...",
    error_while_creating_user: "An error occurred while creating the account. Check the data and try again.",
    success: "Account successfully created!",
    email_verification: "A verification link has been sent to the provided email address.",
    verification_sent: "Thank you for registering. You can log in and use the system now.",
    verification_link_sent: "A verification link has been sent to your email address. Click the link to confirm your account and log in.",
    choose_licenses_description: "Select the licenses your company holds.",
    search_country: "Search country...",
    no_country_found: "Country not found",
    validation: {
      at_least_one_license: "License required",
      maxCharacters: "Maximum number of characters is",
      string: "This field must contain text",
      required: "This field is required",
      email: "This field must contain a valid email address",
      max: "This field can contain a maximum of {number} characters",
      password: "The password must contain at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 digit",
      passwordConfirmation: "Passwords must match",
      regulationsAcceptance: "You must accept the Terms of Use",
      additionalRegulations: "You must accept the additional terms",
      dataProcessing: "Consent to data processing",
      userRole: "Invalid role selected",
      phone: "Invalid phone number",
      name: "First and last name cannot be empty",
      wrongName: "Invalid first name",
      wrongSurname: "Invalid last name",
      wrongCity: "Invalid city",
      wrongCountry: "Invalid country",
      allRequired: "Please fill in all fields",
      onlyNumberInWeight: "This field must contain only numbers",
      onlyNumberInVolume: "This field must contain only numbers",
      onlyNumberInLength: "This field must contain only numbers",
      onlyNumberInPalltesAmount: "This field must contain only numbers",
      role: "Invalid role selected",
      enterNip: "Enter a valid tax number to load company data.",
    },
  },
  forgot_password: {
    reset_password_title: "Reset password",
    text: "If you forgot your account password, please enter your email address.\nWe will send you a message to reset your password.",
    enter_email_placeholder: "Enter email",
    sending: "Sending...",
    send_button: "Send",
    back_button: "Back",
    success_text:
      "We have sent password reset instructions to your email address. If you haven't received the message, please check your spam folder and ensure this email is registered on the XLplanner website.",
    resend_email_again: "Resend email",
    still_no_email: "Still no email?",
    success_send_again: "Email successfully resent",
    fail_send_again: "The email has been sent. If you still haven't received it, please make sure you are registered in the system.",
  },
  reset_password: {
    title: "Reset password",
    verification_code: "Verification code",
    verification_code_placeholder: "Enter verification code",
    password: "New password",
    password_placeholder: "Enter new password",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Confirm new password",
    change_password: "Change password",
    changing_password_in_progress: "Changing password...",
    ready: "Done!",
    password_changed: "Password has been successfully changed.",
    click_to_go_to_login: "Click to go to the login screen",
    invalid_code: "The password reset link has expired. Generate a new one and try again.",
  },
  profile: {
    processing: "Processing...",
    worker_subscription_payment: "Employee subscription payment",
    paying_for_worker: "Subscription payment for: {name} {surname}",
    worker_subscription_description: "Choose your preferred payment provider to proceed.",
    proceed_to_payment: "Proceed to payment",
    waiting_for_acceptance: "You are waiting for administrator confirmation. Until then, some functions may not be available.",
    subscription_payment_title: "Pay subscription for new employee",
    worker_added_successfully: "Employee {name} {surname} has been successfully added!",
    subscription_payment_description: "For the employee to use the system, a subscription must be paid for them.",
    subscription_days: "Number of days",
    subscription_price: "Price",
    pay_subscription_button: "Pay for subscription",
    you_need_subscription: "You must have an active subscription to use the full functionality of the application.",
    you_have_unadded_documents: "Your company has unadded mandatory documents.",
    you_have_unverified_documents: "Your company has unverified documents. Please wait for verification by the administrator.",
    what_do_you_want_to_add: "What do you want to add?",
    choose_one_of_the_options: "Choose one of the following options to go to the screen with the addition form.",
    my_profile_title: "My profile",
    close_edit_title: "Close editing",
    change_image_title: "Change image",
    upload_image_title: "Upload image",
    remove_image: "Remove",
    specjalizations: "Specializations",
    add_new_tag: "Add new tag",
    enter_tag_placeholder: "Enter tag",
    my_profile_edit_title: "Edit profile",
    specialization_title: "Specializations",
    description_title: "Description",
    basic_company_data_title: "Basic company data",
    button_label: "Update information",
    updating: "Updating",
    enter_link_placeholder: "Enter profile link",
    choose_label: "Choose",
    your_profile: "Your profile",
    edit_company: "Edit company data",
    remove_img: "Remove image",
    role: {
      driving_license: "Pilot license",
      car_license: "Vehicle license",
      worker_license: "Pilot license",
      pilot: "Pilot",
      client: "Customer",
      temp: "External",
      admin: "Manager",
      driver: "Carrier",
      warehouse: "Warehouse",
      factory: "Manufacturer",
      user: "User",
      owner: "Administrator",
      worker: "Employee",
      car_policy: "Vehicle policy",
      administrator: "Manager",
      auta_solowe: "Solo vehicles",
      autolaweta_laweta: "Car transporter",
      wywrotka: "Dump truck",
      ciagniki_siodlowe: "Tractor units",
      hakowiec: "Hook lift truck",
      walkingfloor: "Walking floor dump truck",
      bdf_system_przyczepa: "BDF system",
      dluzyca: "Timber trailer",
      dluzyca_przyczepa: "Timber trailer",
      dluzyca_naczepa: "Timber semi-trailer",
      plandeka_bde: "Tarpaulin BDE",
      plandeka_coilmulde: "Tarpaulin Coilmulde",
      plandeka_joloda: "Tarpaulin Joloda",
      plandeka_jumbo: "Tarpaulin Jumbo",
      plandeka_mega: "Tarpaulin Mega",
      plandeka_standard: "Tarpaulin Standard",
      sztywna_zabudowa: "Rigid body",
      sztywna_zabudowa_skrzynia: "Rigid body box",
      chlodnia_hakowka: "Refrigerated hook trailer",
      cysterna_inna: "Other tanker",
      cysterna_silos: "Silo tanker",
      cysterna_spozywcza: "Food tanker",
      podkontenerowa_20_cysterna: "Container 20' tanker",
      podkontenerowa_40_cysterna: "Container 40' tanker",
      podkontenerowa_20_standard: "Container 20' standard",
      podkontenerowa_40_standard: "Container 40' standard",
      podkontenerowa_45_standard: "Container 45' standard",
      podkontenerowa_swapbody: "Container swap body",
      niskopodwoziowy: "Low loader",
      niskopodwoziowy_naczepa: "Low loader",
      niskopodwoziowy_przyczepa: "Low loader trailer",
      bdf_system_naczepa: "BDF system",
      izoterma: "Insulated",
      cysterna_chemiczna: "Chemical tanker",
      cysterna_paliwowa: "Fuel tanker",
      cysterna_gazowa: "Gas tanker",
      chlodnia: "Refrigerated truck",
      platforma: "Platform",
      tandem: "Tandem",
      samochod: "VEHICLE",
      przyczepa: "Trailer",
      przyczepy: "Trailers",
      naczepa: "Semi-trailer",
      naczepy: "Semi-trailers",
      niestandardowy: "Non-standard vehicle",
      custom: "Non-standard vehicle",
      furgon: "Van",
      loading: "Loading",
      reloading: "Reloading",
      unloading: "Unloading",
      krs_cdig: "CEIDG",
      tilt_curtain: "Tarpaulin curtain",
      plandeks_firanka: "Tarpaulin curtain",
      auto: "Auto",
      regon: "Regon",
      nip: "Tax number",
      file: "Other",
      carrier_insurance: "Insurance",
      transport_license: "License",
      contract_terms: "Contract terms",
      npe_application: "Leasing application",
      errors: {
        404: "The employee's role cannot be changed because the company is inactive",
        empty_company: "Company not found",
        empty_user: "Employee not found",
        documents_error: "Verified documents are required to perform the action.",
      },
    },
    statuses: {
      assigned: "Assigned",
      lost: "Offer not selected",
      waiting_for_acceptance: "Waiting for authorization",
      waiting_for_reservation: "Waiting for reservation",
      waiting_for_payment: "Waiting for payment",
      reservation_sent: "Submitted",
      invitation_sent: "Waiting for authorization",
      activated: "Authorized",
      active: "Active",
      blocked: "Blocked",
      deleted: "Deleted",
      pending: "Pending",
      absent: "No vehicle",
      current: "In progress",
      available: "Available",
      rejected: "Rejected",
      retreated: "Withdrawn",
      accepted: "Authorized",
      all: "All",
      finished: "Archived",
      reserved: "Reserved",
      multiple_blocked: "Blocked",
      multiple_active: "Active",
      multiple_rejected: "Rejected",
      loading: "Loading",
      reloading: "Unloading",
      unloading: "Unloading",
      cancelled: "Cancelled",
      car_pending: "No vehicle",
      car_available: "Vehicle available",
      current_monitary: "In progress",
      car_ended: "Ended",
      completed: "Successfully completed",
      not_completed: "Not completed",
      waiting_to_start: "Waiting to start",
      started: "Started",
      WAITING_FOR_VERIFICATION: "Waiting for verification",
    },
    statuses_monitory: {
      rejected: "Rejected",
      cancelled: "Cancelled",
      finished: "Archived",
      accepted: "Confirmed",
      pending: "Pending",
      current: "In progress",
      all: "All",
      absent: "No vehicle",
      waiting_for_acceptance: "Pending",
    },
    company: {
      display_name: "Display name",
      display_name_placeholder: "Display name...",
      please_pick_one_license: "Please select at least one license and add the appropriate document",
      company_data: "Company data",
      my_company: "My company",
      edit: "Edit company data",
      basic_data: "Basic company data",
      name: "Company name",
      address: "Company address",
      city: "City",
      zip_code: "Postal code",
      nip: "Tax number",
      regon: "Regon",
      province: "Province",
      update_success: "Data successfully updated",
      addWorker: "Employee successfully added. Please wait for their confirmation by the system administrator.",
      avatar: "Company profile picture",
      galery: "Company gallery",
      showGalery: "Click to see the entire gallery",
      emptyCompany: "You are not registered with any company",
      administrator_amount: "Number of administrators",
      department_amount: "Number of departments",
      you_dont_own_departments: "You don't have any departments",
      validation: {
        display_name_max: "The display name can be up to 50 characters long.",
        compnay: "The company name must be a string",
        address: "The address must be a string",
        zip_code: "Invalid postal code. Min. number of characters is 3. Max. number of characters is 10.",
        zip_code_pl: "Invalid postal code. Correct format is XX-XXX.",
        max_nip: "The tax number must consist of min. 9 digits",
        regon_only_number: "Regon must be a sequence of digits",
        max_regon: "Regon must consist of 9 digits",
        authorizationError: "No authorization to edit",
      },
    },
    personal_data: {
      basic_data: "Your basic data",
      firstname: "First name",
      enter_firstname: "Enter first name",
      lastname: "Last name",
      enter_lastname: "Enter last name",
      email: "Email",
      enter_email: "Enter email",
      phone: "Phone number",
      enter_phone: "Enter phone number",
      second_phone: "Phone number 2",
      enter_second_phone: "Enter phone number 2",
      update_info: "Update information",
      updating_info: "Updating...",
    },
    validation: {
      wrong_url: "Invalid URL address",
      weight: "The field may only consist of digits",
      volume: "The volume may only consist of digits",
      number_of_pallets: "The number of pallets may only consist of digits",
    },
    add_user: {
      driver_add: "Driver added",
      licenses: "Licenses",
      upload_license_document: "Select a document that confirms the license",
      list: "Employee list",
      title: "Add employee",
      added_worker: "New employee has been successfully added",
      email_placeholder: "Enter employee's email address",
      message: "Message (optional)",
      name: "First name",
      name_placeholder: "Enter first name",
      surname: "Last name",
      surname_placeholder: "Enter last name",
      email: "Email address",
      phone: "Phone number",
      phone_placeholder: "Enter phone number",
      add: "Add employee",
      add_driver: "Add driver",
      adding: "Adding...",
      type: "User type",
      choose_type: "Select user type",
      enter_worker_data: "Enter employee data",
      enter_driver_data: "Enter driver data",
      admin: "Manager",
      owner: "Owner",
      status: "User status",
      active: "Active",
      worker: "Employee",
      edit_complete: "Employee data successfully changed",
      assign_department: "Assign department",
    },
    add_warehouse: {
      list: "Warehouse list",
      added_warehouse: "New warehouse successfully added",
      added_department: "New department successfully added",
      title: "Add new warehouse",
      edit_title: "Edit warehouse",
      name: "Name",
      name_placeholder: "Enter warehouse name",
      address: "Warehouse address",
      city: "Location",
      city_placeholder: "Enter city",
      street: "Street and number",
      street_placeholder: "Enter warehouse address",
      zipCode: "Postal code",
      zipCode_placeholder: "Enter postal code",
      country_code: "Country code",
      country_code_placeholder: "Enter country code",
      email_placeholder: "Enter warehouse email address",
      phone_placeholder: "Enter warehouse phone number",
      type: "Authorization type",
      automatic: "Automatic",
      add: "Add warehouse",
      adding: "Adding warehouse...",
      delete_complete: "Warehouse successfully deleted",
      edit_complete: "Editing successfully completed.",
      invitation_sent: "Employee added to department",
    },
    add_department: {
      list: "Department list",
      added_warehouse: "New department successfully added",
      title: "Add department",
      edit_title: "Edit department",
      name: "Name",
      name_placeholder: "Enter name",
      address: "Department address",
      city: "Location",
      city_placeholder: "Enter city",
      street: "Street and number",
      street_placeholder: "Enter address",
      zipCode: "Postal code",
      zipCode_placeholder: "Enter postal code",
      country_code: "Country code",
      country_code_placeholder: "Enter country code",
      email_placeholder: "Enter email address",
      phone_placeholder: "Enter phone number",
      type: "Authorization type",
      automatic: "Automatic",
      add: "Add department",
      adding: "Adding department...",
      delete_complete: "Department successfully deleted",
      edit_complete: "Department successfully edited",
      no_download: "Data regarding department/warehouse cannot be downloaded.",
      authorizationHint:
        "Authorization with the carrier is required to perform notifications. You authorize by accepting a request sent by the carrier. After activating this option, all requests sent to this warehouse will be automatically accepted without manual confirmation.",
    },
    add_car: {
      policy_info: "The insurance policy you added must be approved by the system administrator. Until then, you cannot use this vehicle.",
      policy: "Policy number",
      policy_from: "Policy validity (from)",
      policy_to: "Policy validity (to)",
      overview_from: "Inspection validity (from)",
      overview_to: "Inspection validity (to)",
      policy_placeholder: "Enter policy number",
      insurer: "Insurer name",
      insurer_placeholder: "Enter insurer name",
      title: "Add new vehicle",
      edit_title: "Edit vehicle",
      name: "Brand",
      name_placeholder: "Enter vehicle brand",
      trailerNumber: "Semi-trailer registration number",
      trailerNumber_placeholder: "Enter semi-trailer registration number",
      registrationNumber: "Registration number",
      registrationNumber_placeholder: "Enter registration number",
      type: "Vehicle type",
      type_placeholder: "Enter vehicle type",
      add: "Add vehicle",
      adding: "Adding vehicle...",
      delete_complete: "Vehicle successfully deleted",
      edit_complete: "Vehicle successfully edited",
      add_complete: "Successfully added",
      pick_car_type: "Select vehicle subtype",
      go_to_cars: "Go to vehicles",
      pick_department_to_add_car: "Select department",
    },
    add_samochod: {
      title: "Add new vehicle",
      edit_title: "Edit vehicle",
      name: "Brand",
      name_placeholder: "Enter vehicle brand",
      trailerNumber: "Semi-trailer registration number",
      trailerNumber_placeholder: "Enter semi-trailer registration number",
      registrationNumber: "Registration number",
      registrationNumber_placeholder: "Enter registration number",
      type: "Vehicle type",
      type_placeholder: "Enter vehicle type",
      add: "Add vehicle",
      adding: "Adding vehicle...",
      delete_complete: "Vehicle successfully deleted",
      edit_complete: "Vehicle successfully edited",
      add_complete: "Successfully added",
      pick_department_to_add_car: "Select department",
    },
    add_solo_cars: {
      policy: "Add insurance policy",
      title: "Add new vehicle",
      edit_title: "Edit vehicle",
      name: "Brand",
      name_placeholder: "Enter vehicle brand",
      vim: "VIN",
      vim_placeholder: "Enter VIN",
      registrationNumber: "Registration number",
      registrationNumber_placeholder: "Enter registration number",
      add: "Add vehicle",
      adding: "Adding vehicle...",
      customName: "Custom name",
    },

    list_vehicles: {
      auta_solowe: "Display solo vehicles for:",
      ciagniki_siodlowe: "Display tractor units for:",
      przyczepa: "Display trailers for:",
      naczepa: "Display semi-trailers for:",
      samochod: "Display vehicles for:",
      all: "Display all vehicles for:",
      custom: "Show {0} {1} for:",
      pick_department: "Select department",
    },
    list_auth: {
      accepted: "Accepted authorizations",
      pending: "Pending authorizations",
      company: {
        name: "Company name",
      },
      department: {
        count: "Number of departments",
        count_d: "Number of warehouses",
        show: "Departments",
        name: "Department name",
        empty_departments: "You are not assigned to any department",
      },
    },
    add_documents: {
      success: "Document has been successfully added. Please wait for verification by the administrator.",
      file_uploaded: "File has been successfully added",
      add_file: "Add new file",
      title: "Add new document",
      select: "Select file to upload (max. 10 MB)",
      desc: "Short document description (max. 200 characters)",
      visible: "Document visible to all (public)",
      choose_file: "Select file",
      choose_files: "Select files",
      no_files_chosen: "No file selected",
      adding: "Document is being loaded...",
      add: "Add document",
      file_size_error: "File too large",
      no_file_error: "No file uploaded.",
      no_access: "You don't have access to this document type",
      file_type_error: "Inappropriate file format",
      delete_error: "Error deleting image",
      accept_doc_confirm: "Are you sure you want to accept the document?",
      reject_doc_confirm: "Are you sure you want to reject the document?",
    },
    calendar: {
      ramps: ramps,
      warehouse: "Warehouse",
      name: "Warehouse name",
      fill: "Fill calendar",
      fill_department_calendar: "Create calendar",
      taken: "Occupied",
      time_windows: "Time windows",
      slots: "Number of available slots",
      from: "Warehouse available from:",
      to: "Warehouse available to:",
      delete: "Delete time window",
      deleteAll: "Delete all time windows",
      deleteAllQuestion: "Do you want to delete all time windows from this day?",
      show_monitary: "Show notifications",
      monitary_id: "Notification ID",
      company_id: "Company ID",
      worker_id: "Employee ID",
      give_additional_monitory_note_id: "Assign additional notification ID (optional)",
      confirm_monitory_note_rejection: "Are you sure you want to reject the notification?",
      confirm_monitory_note_archive: "Are you sure you want to end the notification?",
      confirm_authorization_rejection: "Are you sure you want to reject the authorization?",
      monitary_time: "Notification time",
      driver: "Driver data",
      wehicle: "Vehicle data",
      add: "Add time window",
      enter_limit: "Enter limit for loadings and unloadings per day",
      you_can_add_more: "You can create more time windows",
      creating: "Calendar is being created",
      for_month: "For the month:",
      weekday: "Weekday",
      interval: "Time window length",
      interval_short: "Interval (minutes)",
      block_monitary: "No notification possibility",
      limitless_monitary: "Unlimited notification possibility",
      add_succes: "Calendar successfully added",
      edit_succes: "Time window successfully edited",
      add_error: "Error adding calendar",
      add_data_missing: "Incorrectly filled data",
      limit: "All limits for loadings and unloadings must be filled.",
      empty_hours: "Hours and minutes of time windows cannot be empty",
      empty_interval: "The time window length cannot be empty or last 0 minutes.",
      wrong_hours: "The time window length hours are incorrectly filled.",
      same_hour_error: "Start and end time of the window must be different.",
      fill_all_boxes: "Fill all fields",
      correctly_fill_all_boxes: "Fill all fields correctly",
      create_calendar: "Create calendar",
      monitory_note_calendar: "Notification calendar",
      emptyCalendar: "No calendar for the specified month",
      unlimited: "Unlimited loadings/unloadings",
      loadLimit: "Loading limit",
      unloadLimit: "Unloading limit",
      enter_load_nr: "Enter number of loads",
      date_error: "Actions on time windows of past days are prohibited",
      copyPreviousMonth: "Copy previous month",
      calendarHint: "Request filling",
      errors: {
        startHour: "Incorrect opening time.",
        endHour: "Incorrect closing time.",
        interval: "Incorrect window length.",
      },
    },
    document: {
      empty_company: "All added documents will be displayed in this tab",
      index: "No.",
      originalname: "File name",
      description: "File description",
      createdAt: "Added on",
      addedBy: "Added by",
      visible: "Visible",
      action: "Action",
      title: "Documents",
      emoty_document_type: "No documents",
    },
    stock: {
      loadingTime: "Time",
      my_cancelled_orders: "Cancelled orders",
      numberOfPilots: "Number of pilots",
      "pilot-offers": "Pilot offers",
      numberOfNights: "Number of nights",
      pricePerKm: "Price per kilometer",
      minOfferAmount: "Minimum offer",
      inactive: "Auction inactive",
      license: "License",
      driver: "Carrier",
      distanceInKm: "Distance in km",
      enter_auction_data: "Enter order data",
      step2Title: "Complete details of all loads",
      add_auction: auction_adding,
      types: {
        auction: "Auction",
        predetermined: "Assigned transport",
        group: "For group",
        public: "Public",
      },
      add_order: {
        invalid_time_range: "Unloading time must be later than loading time",
        end_time_reset_warning: "Unloading time has been reset because it was earlier than loading time",
        end_time_after_start: "Unloading date and time must be later than loading date and time",
        min_pilots: "The minimum number of pilots is 1",
        end_date_after_start: "The end date must be after the start date",
        invalid_date_range: "The start date cannot be after the end date",
        start_date_in_past: "The start date must be in the future",
        end_date_reset_warning: "The end date has been automatically reset because it was before the new start date",
        from: "Loading location and date",
        to: "Unloading location and date",
        license_requirements: "Escort vehicle requirements",
        pilots_count: "Number of escort vehicles",
        required_licenses: "Required license",
        max_pilots: "Maximum number of escort vehicles is 10",
        order_number: "Order number",
        pick_currency: "Select currency",
        length: "Length",
        width: "Width",
        height: "Height",
        dimension_error: "Invalid value",
        weight_error: "Invalid value",
      },
      signature: {
        loader: "Sender signature",
        carrier: "Receiver signature",
        redo: "Sign again",
      },
      changelog: {
        numberofpilots: "Number of pilots",
        distanceinkm: "Distance (km)",
        license: "License",
        flatrate: "Flat rate",
        cargodescription: "Cargo description",
        cargolength: "Cargo length",
        cargodocumentnumber: "Document number",
        cargoremarks: "Additional description",
        cargovolume: "Cargo volume",
        cargoweight: "Cargo weight",
        cargonumberofpallets: "Number of pallets",
        surcharge: "Surcharge",
        surcharges: "Surcharge",
        date: "Changes from:",
        treshold: "Overbid threshold",
        title: "Auction change log",
        no_data: "No changes in log",
        startingprice: "Minimum price",
        numberdeliveries: "Number of deliveries",
        idloader: "Loader ID",
        dateofloading: "Start date",
        dateofoperation: "Operation date",
        numberofitems: "Number of items",
        dateofunloading: "Unloading date",
        deadline: "End",
        paymentdeadline: "Payment deadline",
        numberofpallets: "Number of pallets",
        volume: "Volume",
        weight: "Weight",
        deliveriesnumber: "Number of loads",
        documentnumber: "Document number",
        description: "Description",
        length: "Length",
        ordernumber: "Order number",
        loadingcity: "Loading city",
        loadingcityzipcode: "Loading postal code",
        loadingCountry: "Loading country",
        loadingcitycountry: "Loading country",
        unloadingcity: "Unloading city",
        unloadingcityzipcode: "Loading postal code",
        unloadingCountry: "Unloading country",
        unloadingcitycountry: "Unloading country",
        loadingweight: "Loading weight",
        loadingvolume: "Loading volume",
        loadinglength: "Loading length",
        remarks: "Transport comment",
        currency: "Currency",
        ordertype: "Offer type",
        cartype: "Vehicle type",
        loadingplace: "Loading place",
        unloadingplace: "Unloading place",
        loadingplaceShort: "Loading",
        unloadingplaceShort: "Unloading",
        cityPlaceholder: "Enter city",
        additional: "Additional info",
        maxLoadings: "Max. number of loadings",
        maxUnloadings: "Max. number of unloadings",
        endDate: "Completion deadline",
      },
      transactions: {
        title: "Company transaction journal",
        empty: "No transactions for the specified period",
      },
      cant_add_offer: "No active subscription",
      buy_sub: "Buy subscription",
      adding_offer: "Submit offer",
      auto_offering: {
        title: "Minimum price / automatic overbidding",
        price: "Minimum auction price:",
        enabled: "Automatic offer overbidding is set.",
        title_short: "Automatic offer overbidding",
        min_price: "Minimum amount",
        save: "Save changes",
        no_offers: "You have not yet submitted any offers for this auction.",
      },
      car_part: "Type of trailer / semi-trailer",
      auction_number_short: "Order no.",
      part: "Trailer / semi-trailer",
      load_warehouse: "Loading warehouse",
      unload_warehouse: "Unloading warehouse",
      deadlineNoCounter: "Auction end",
      auction_details: "Order details",
      do_you_want_offer: "Are you sure you want to accept the offer?",
      do_you_want_offer_reject: "Are you sure you want to reject the offer?",
      document_error: "You cannot download the document",
      document_error_details: "The shipping document is not yet available for this order.",
      included_transactions: "Submitted offers",
      surcharges_to_transport: "Surcharges to transports",
      adding_ofer: "Submit offer",
      added_files: "Added files",
      no_files: "No attachments",
      loadingCountries: "Transport start",
      informationAboutLoad: "Information about the load",
      loadingDates: "Start date",
      unloadingCountries: "Transport end",
      unloadingDates: "Unloading dates",
      department_data: "Department data",
      department_name: "Department name",
      department_address: "Department address",
      offerType: "Offer type",
      participantsNumber: "Number of participants",
      offer: "Offer",
      priceFrom: "Calculated price",
      bindingFrom: "Binding from",
      bindingTo: "Binding to",
      given: "Given",
      givenFrom: "Given from",
      date: "Date",
      loadingType: "Loading type",
      loading: "Loading",
      unloading: "Unloading",
      lowest_prices: "Lowest proposed prices",
      numberOfCargo: "Number of loads.",
      detailsOfCargo: "Load details",
      companyName: "Company name",
      location: "Location",
      loadingPoints: "Loading units",
      loadingPlaces: "Individual loading places",
      price: "Price",
      placeOfDisposal: "Disposition place",
      disposal: "Dispatcher",
      car: "Vehicle",
      nrTransport: "Transport information",
      lastModifiedDate: "Last modification date",
      idTransporeon: "XLplanner ID",
      idLogiPlanner: "XLplanner ID",
      idShipper: "Shipper ID",
      category: "Weight category (kg)",
      shipperName: "Shipper name",
      shipper: "Shipper",
      users: "Issuing employee",
      delivers: "Deliveries (number of unloadings)",
      deliversLoads: "Deliveries (number of loadings)",
      cargos: "Number of loads",
      typeOfOrder: "Type of order",
      quot: "%Quote",
      loadingDate: "Start date",
      unloadlingDate: "Unloading date",
      deadline: "Auction end",
      lastModification: "Last modification date",
      loadingCity: "Loading city",
      loadings: "Transport start",
      unloadings: "Transport end",
      postCode: "Postal code",
      country: "Country",
      unLoadingCity: "Unloading city",
      carType: "Vehicle type",
      typeOfCar: "Vehicle type",
      currentAuctionPrice: "Current price",
      deliverAmount: "Number of deliveries",
      weight: "Loading weight",
      weightT: "Loading weight (t)",
      volumeM: "Loading volume (m³)",
      volume: "Volume",
      length: "Loading length",
      lengthM: "Loading length (m)",
      remarks: "Remarks",
      canceled_transports: "Cancelled transports",
      cancel_order: "Cancel order",
      end_order: "End order",
      orders_archive: "Order archive",
      cancelled_orders: "Cancelled orders",
      comment: "Transport comment",
      terms: "Contract terms",
      selected_transports: "Assigned transports",
      rejected_transports: "Unassigned transports",
      no_won_auctions: "No won auctions",
      no_selected_transports: "No assigned transports",
      no_canceled_transports: "No cancelled transports",
      no_selected_transports_lost: "No unassigned transports",
      unreceived_transports: "Unreceived transports",
      created_groups: "Created groups",
      extra_charges: "Extra charges",
      startingPrice: "Minimum price",
      no_attachment: "No attachments",
      dateAndHour: "When added",
      offerSum: "Amount",
      surchargeTitle: "Additional costs",
      status: "Status",
      my_offers: "My offer for this order",
      all_offers: "All offers in this auction",
      no_offers: "You have not yet submitted any offers for this auction",
      my_waiting_offers: "My assigned transports from auctions",
      offer_details: "Offer details",
      offer_placing_department: "Department from which the offer was submitted",
      offer_placing_user: "User who submitted the offer",
      offer_removal_confirmation: "Are you sure you want to withdraw the offer?",
      which_auction: "Auction to which the offer relates",
      company_placing_auction: "Shipper",
      additional_pays: "Surcharges",
      winning_offer: "Winning offer",
      templateName: "Template name",
      nameTemplate: "Name template",
      auction_removal: "Are you sure you want to cancel this order?",
      loadReservation: "Reserve loading time",
      unloadReservation: "Reserve unloading time",
      startPoint: "Start point",
      endPoint: "End point",
      statuses: {
        assigned: "Assigned",
        waiting_for_reservation: "Waiting for reservation",
        waiting_for_payment: "Waiting for payment",
        reservation_sent: "Submitted",
        pending: "Pending",
        outbid: "Outbid",
        accepted: "Accepted",
        delivery_accepted: "Assigned",
        delivery_canceled: "Cancelled",
        delivery_rejected: "Unassigned",
        reserved: "Reserved",
        canceled: "Cancelled",
        finished: "Finished",
        cancelled: "Cancelled",
        active: "Active",
        rejected: "Rejected",
        won: "Won",
        all: "All",
      },
      bid: {
        referencePrice: "Automatic overbidding",
        autoConquerUntill: "Up to what amount",
        takeReferencePrice: "Use reference price",
        type: "Offer type",
        offer: "Offer",
        price: "Calculated price",
        dateRange: "Binding until",
        carId: "Select vehicle",
        departmentId: "Department",
        comment: "Offer comment",
        commentPlaceholder: "Offer comment - visible to carrier and shipper",
        submit: "Submit offer",
        cancel: "Cancel",
        price_error: "The field must be a decimal number greater than zero with a maximum of two decimal places.",
        capasity_error: "The field must be a decimal number greater than zero with a maximum of two decimal places.",
        palletAndPiecesError: "The field must be greater than zero with a maximum of two decimal places.",
        maxValue: "Maximum value is:",
        full_number_error: "The field must be an integer",
      },
      deliverInfo: {
        widthWord: "Width",
        heightWord: "Height",
        loadingPlace: "Loading place",
        map: "Map",
        weight: "Dimensions and weights",
        unloadingPlace: "Unloading place",
        other: "Other",
        deliver: "Delivery",
        weightWord: "Weight",
        lengthWord: "Length",
        capasityWord: "Volume",
        surcharge: "Surcharge",
        licenseType: "License type",
      },
      contactDetails: {
        user_data: "Person issuing the order",
        user: "Contact person",
        phone: "Phone",
        cell_phone: "Mobile phone",
      },
    },
    languages: {
      title: "Change application language",
      current: "Currently selected language:",
    },
    listing_departments: {
      title: "List of available warehouses",
      title_drivers: "List of available carriers",
      authorize: "Send authorization request",
      authorized: "Authorized",
    },
  },
  payments: {
    choose_payment_provider: "Choose your payment provider",
    empty_wallet: {
      title: "To make a payment for notification, you must first top up your wallet",
      under_title: "Choose one of the available time window packages to proceed to payment:",
    },

    list: {
      status: "Transaction status",
      date: "Transaction date",
      doc: "Notification document",
      department: "Carrier",
      value: "Amount",
      time_windows: "Purchased windows",
      company: "Company",
      invoice: "Invoice",
      download: "Download invoice",
      no_invoice: "The invoice will appear at the beginning of the month",
      history: "Transaction history",
      history_short: "History",
    },
    spelling: {
      window: "Time window",
      more_windows: "Time windows",
      multiple_windows: "Time windows",
      day: "Day subscription",
      days: "Days subscription",
    },
    number_of_users: "Number of users",
    invoices: "Invoices",
    windows: "Time windows",
    spent_windows: "Used windows",
    returned_windows: "Returned windows",
    days: "Subscription days",
    sub: "Subscription",
    extend_sub: "Extend subscription",
    buy_sub: "Buy subscription",
    none: "None",
    no_active_sub: "No active subscription",
    subscription_end: "Subscription active until",
    success: "Payment successfully completed",
    success_monitory: "Payment successfully completed. Notification paid",
    confirmation: "Are you sure you want to confirm and pay for the notification?",
    sum: "Current account balance",
    sum_after: "Account balance after transaction",
    currencyTime: "Number of time windows",
    charge: "Top up account",
    package_choice: "Select top-up package",
    sub_package: "Subscription packages",
    win_package: "Time window packages",
    admin: {
      add: "Add package",
      edit: "Edit price list",
      info1: "Press 'Add package' to add a new price package.",
      info2: "To delete an existing package, press the X next to it.",
      price: "Price",
      price_placeholder: "Enter package price",
      monitoryNotesNumber: "Number of time windows",
      monitoryNotesNumber_placeholder: "Enter number of time windows",
      daysNumber: "Number of subscription days",
      description: "Additional package description (optional)",
    },
    errors: {
      required: "Field required",
      price: "Wrong price. The price must be positive and consist only of digits. Decimal places should be separated by a dot",
      number: "The field must be a positive integer.",
      monitoryNotesNumber: "The number must consist only of digits",
      bad_payment: "The payment could not be processed.",
      payment_too_long: "Payment processing took too long.",
    },
    currency: "ZŁ",
  },
  profile_settings: {
    settings: "Change password",
    password_change: "Change password",
    password_change_success: "Password successfully changed",
    current_password: "Current password",
    current_password_placeholder: "Enter current password",
    new_password: "New password",
    new_password_placeholder: "Enter new password",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Confirm password",
    update_information: "Update information",
    two_step_verification: "Two-factor authentication",
    two_step_verification_desc: "Additionally secure your account with a second login step.",
    two_step_verification_active: "Enabled",
    two_step_verification_inactive: "Disabled",
    select_verification_method: "Select verification method",
    privacy_settings: "Privacy settings",
    receiving_notifications_about_forum_threads: "I don't want to receive notifications about forum threads",
    receiving_notifications_about_comments: "I don't want to receive notifications about comments on my inspirations",
    commenting_user_projects_by_others: "I don't allow other users to comment on my inspirations",
    receiving_notifications_of_ratings_by_others: "I don't want to receive notifications about my ratings by other users",
    receiving_messages_from_others_users: "I don't want to receive messages from other portal users (does not apply to administrator)",
    profile_indexing: "I don't allow indexing of my profile, projects, inspirations by search engines",
    add_user_request: "Do you want to accept the invitation?",
    invitation_accepted: "Invitation has been accepted",
    invitation_rejected: "Invitation has been rejected",
    invitation_processed: "Invitation processed",
    click_to_go_to_main_page: "Click to go to the main page",
  },
  monitary_notes: {
    title: "New notification assistant",
    wrong_hours: "Incorrect window times",
    step_one_title: "Selection of operation type and location",
    step_one_two: "Selection of provision date and time",
    step_one_three: "Providing information about the load",
    operation: "Operation type",
    department: "Select the department from which you want to notify.",
    warehouse: "Select the warehouse you want to notify",
    next: "Next",
    warehouse_chosen: "Selected warehouse",
    no_free_time_windows: "No free time windows",
    hour: "Select provision time",
    save: "Save notification",
    cargoType: "Load type",
    weight: "Load weight",
    length: "Load length (m)",
    capacity: "Load volume (m³)",
    numberOfPallets: "Number of pallets",
    numberOfPieces: "Number of pieces",
    numberOfDocument: "Document number",
    identityDoc: "ID document no.",
    driverEmail: "Driver email",
    additionalDescription: "Additional description",
    tractorNumber: "Tractor number",
    semitrailerNumber: "Semi-trailer registration",
    name: "Driver's first and last name",
    driverDocument: "Driver's ID document number",
    driverDocumentShort: "ID document number",
    driverPhone: "Driver's phone number",
    car_registration_number: "Vehicle registration number",
    pick_car: "Select vehicle",
    pick_trailor: "Select trailer (optional)",
    pick_semitrailor: "Select semi-trailer",
    monitary_note_added: "Notification added",
    status_changed: "Status changed",
    monitary_notes_archive: "Notification archive",
    car_status: "Vehicle status",
    monitary_note_changed: "Notification edited",
    monitory_notes_list: "List of notifications for the specified time window",
    empty_monitory_notes: "No notifications",
    show_monitary_for: "Show notifications for",
    driver_came: "Driver has arrived",
    driver_didnt_come: "No driver",
    confirm_adding: "Are you sure you want to accept the notification?",
    load_details: "Load details",
    load_number: "Load {0}.",
    monitary_modal: {
      description: "Type of unloading",
      numberOfPallets: "Number of pallets",
      consignmentNumber: "Document number",
      registrationNumber: "Vehicle registration number",
      date: "Document number",
      volume: "Load volume (m³)",
      length: "Load length (m)",
      weight: "Load weight",
      driverFullName: "Driver's first and last name",
      driverPhone: "Driver's phone number",
      driverEmail: "Driver's email",
      driverDocument: "Driver's ID document no.",
      additionalDescription: "Additional information",
      carId: "Vehicle registration number",
      semitralerId: "Trailer registration",
      semitrailerNumber: "Trailer registration",
      trailerNumber: "Semi-trailer registration",
      tralerId: "Semi-trailer registration",
      remarks: "Additional information",
    },
    errors: {
      no_hour: "Mark provision time",
    },
  },
  auction_adding: {
    location_placeholder_flexible: "Enter city or exact address",
    location_hint: "You can enter only a city (e.g. Berlin) or a complete address (e.g. Alexanderplatz 1, Berlin)",
    city_location: "City",
    address_location: "Exact address",
    location_incomplete: "Please select a location from the suggestion list",
    no_licenses_title: "No assigned licenses",
    no_licenses_description:
      "You cannot add a pilot offer because no licenses are assigned to your company profile. To continue, you must first add licenses to your company profile.",
    add_licenses_title: "Add licenses to profile",
    add_licenses_description: "Select the licenses you want to add to your company profile:",
    add_licenses: "Add licenses",
    licenses_added_success: "Licenses successfully added",
    archive_empty: "No orders in archive",
    delete_offer_confirmation: "Are you sure you want to delete this offer?",
    no_offers_added: "No offers submitted",
    no_transactions_included: "You have not created any offers for orders",
    start_bid: "Search for orders",
    update: "Update",
    "pilot-offer-title": "Add pilot offer",
    location: "Location",
    location_placeholder: "Enter address...",
    location_required: "Location is required",
    selected_location: "Selected location",
    country: "Country",
    city: "City",
    zip_code: "Postal code",
    street: "Street",
    start_date: "Start date",
    end_date: "End date",
    max_radius: "Maximum radius to start",
    max_radius_placeholder: "Enter maximum radius...",
    select_licenses: "Select licenses",
    select_licenses_description: "Mark the licenses you want to use for this offer",
    license_required: "Select at least one license",
    submit: "Save",
    start_date_required: "Start date is required",
    end_date_required: "End date is required",
    end_date_after_start: "The end date must be after the start date",
    radius_integer: "The value must be an integer",
    radius_min: "Minimum value is 1",
    radius_max: "Maximum value is 999999",
    radius_required: "Maximum radius is required",
    radius_number: "The value must be a number",
    download_document: "Download shipping document",
    title: "Add auction",
    startingPrice: "Minimum price",
    numberDeliveries: "Deliveries (number of unloadings)",
    numberOfLoadings: "Deliveries (number of loadings)",
    dateOfLoading: "Start date",
    dateOfUnloading: "Unloading date",
    deadline: "Auction end",
    loadingCity: "Loading city",
    loadingCityZipCode: "Loading postal code",
    loadingCountry: "Loading country",
    unloadingCity: "Unloading city",
    unloadingCityZipCode: "Unloading postal code",
    unloadingCountry: "Unloading country",
    loadingAddress: "Loading address",
    unloadingAddress: "Unloading address",
    loadingWeight: "Load weight",
    loadingVolume: "Load volume",
    loadingLength: "Load length",
    currency: "Auction currency",
    currency_short: "Currency",
    for_day: "For the day",
    calc: "Calculator",
    hide: "Hide",
    rest_of_currencies: "Other currencies",
    carType: "Vehicle type",
    carPart: "Trailer/semi-trailer type",
    departmentLoaderId: "Issuing department",
    recipients: "Recipients",
    remarks: "Additional information",
    save: "Add order",
    surcharge: "Surcharge (optional):",
  },
  tableData: tableDetails,
  validate: {
    email: "The email provided is invalid",
    required: "The field is required",
    empty: "The field cannot be empty.",
    wrong_city: "Wrong city name",
    password: "The password should contain: min. 8 characters, min. 1 uppercase letter, min. 1 lowercase letter, min. 1 number",
    passwordConfirmation: "The passwords must be identical",
    min_number: "The value must be greater than {number}",
  },
  error_codes: {
    "000": "User does not exist",
    "001": "Invalid credentials",
    "002": "The email provided already exists in the system",
    "003": "Invalid token",
    "004": "Invalid request",
    "005": "User is already registered via the Google platform",
    "006": "User is already registered via the Facebook platform",
    "007": "Invalid verification code",
    "008": "Cart not found",
    "009": "Account not verified. Email with code has been sent.",
    "010": "Product has already been added to favorites",
    "011": "Object already exists",
    "012": "Wrong password",
    "013": "@TODO CODE TO COMPLETE",
    "014": "An invitation has already been sent to the provided email address",
    401: "No authorization",
    403: "No permission to perform this action",
    404: "Object not found",
    default: "An error occurred while processing the request.",
  },
  verification: {
    title: "Account verification",
    in_progress: "Please be patient, verification is in progress...",
    success: "The account has been verified. You can log in.",
    error_during_verification: "An error occurred during verification. Make sure the link is correct.",
  },

  page_not_found: {
    desc: "Unfortunately, the page you were looking for was not found. Check if you entered the correct address.",
    back: "Back to main page",
  },
  alert: {
    successfully_saved_data: "Data successfully saved",
    successfully_updated_data: "Data successfully updated",
    error_during_saving_data: "Error saving data",
    error_during_updating_data: "Error updating data",
  },
  menu: {
    auctionsDashboard: "Exchange dashboard",
    "add-offer": "Add offer",
    "my-offers": "My offers",
    "pilot-bid": "Pilot exchange",
    price: "Price list",
    adverts: "Advertising",
    mass_message: "Group message",
    admin_chat: "Chats with administrator",
    user_chat: "User chats",
    chat: "Messages",
    language: "Language",
    widgets: "Widgets",
    dashboard: "Dashboard",
    my_company: "Company",
    my_profile: "My profile",
    my_drivers: "Drivers",
    my_warehouses: "My departments",
    my_warehouses_outside: "External warehouses",
    list_warehouses: "Warehouse list",
    my_factories: "My warehouses",
    my_cars: "My vehicles",
    time_windows: "Time windows",
    monitory_notes: "Notifications",
    authorizations: "Authorizations",
    archive: "Archive",
    calendar: "Calendar",
    settings: "Settings",
    raports: "Reports",
    loads: "Freights",
    tenders: "Tenders",
    workers: "Employees",
    documents: "Documents",
    warehouses: "Departments",
    contracts: "Orders",
    subscription: "Subscription",
    subscriptions: "Subscription",
    warehouseList: "Warehouse list",
    warehouse_menagers: "Warehouse employees",
    department_menagers: "Department employees",
    admin_panel: "Administrator panel",
    change_company: "Change active company",
    logout: "Log out",
    your_companies: "Your companies",
    companies: "Companies",
    timeWindow: "Time windows",
    bid: "Exchange",
    bank: "Bank",
    invoices: "Payment list",
    drivers: "Carriers",
    drivers_groups: "Pilot groups",
    drivers_list: "Carrier list",
    job_list: "Order list",
    factoring_list: "Factoring list",
    participants_list: "Participant list",
    insurances: "Insurance",
    auctions: "Exchange",
    offers: "Offers",
    lack_of_other_companies: "No other companies",
    return: "Back",
    help: "Help",
    chat_with_admin: "Chat with admin",
    pickCompanyToConnect: "Select from the dropdown list the company you want to switch to.",
    auctionPayment: "Commission from auctions",
    verificationPayments: "Verification transfers",
    collapse_menu: "Collapse menu",
    expand_menu: "Expand menu",
    admin: {
      users: "Users",
      users_logiplanner: "XLplanner",
      company: "Company data",
    },
  },
  admin: {
    general: {
      back: "Back",
      button_update_data_title: "Update information",
      add: "+Add employee",
    },
    dashboard: {
      pilots: "Pilots",
      companies: "Registered companies",
      carriers: "Carriers",
      factories: "Manufacturers",
      warehouses: "Warehouses",
      waitingCompanies: "Waiting",
      value: "Total",
      blocked: "Blocked",
      waiting_for_acceptance: "Waiting",
      activated: "Accepted",
    },

    profile: {
      my_profile_title: "My profile",
      my_profile_settings_title: "Settings",
      personal_image: "Main image",
      update_success: "Data successfully updated",
      img_update_success: "Image successfully updated",
      img_delete_success: "Image successfully deleted",
      showGallery: "Show gallery",
      address_title: "Address",
      department_phone: "Contact",
      department_email: "Email address",
      name: "First name",
      enter_name: "Enter first name",
      surname: "Last name",
      enter_surname: "Enter last name",
      email: "Email",
      enter_email: "Enter email",
      phone_number: "Phone number",
      enter_phone_number: "Enter phone number",
      street: "Street",
      enter_street: "Enter street",
      premises_number: "House number",
      enter_premises_number: "Enter house number",
      apartment_number: "Apartment number",
      enter_apartment_number: "Enter apartment number",
      zip_code: "Postal code",
      enter_zip_code: "Enter postal code",
      city: "City",
      enter_city: "Enter city",
      validation: {
        zip_code: "Invalid postal code. Min. number of characters is 3. Max. number of characters is 10.",
      },
      update_data_success: "Profile data successfully updated",
      update_profile_img: {
        alert_success: "Profile image successfully updated",
      },
      delete_profile_img: {
        alert_success: "Profile image successfully deleted",
      },
      settings: {
        back: "Back",
        my_profile: "My Profile",
        settings: "Settings",
        manage_account: "Manage Your Account",
        change_default: "Change Default Factoring Commission",
        set_provision: "Factoring Commission:",
        change_provision: "Change Commission",
        change_password: "Change Password",
        close_dialog: "Close",
        changing_password: "Change Password",
        old_password: "Old Password",
        old_password_placeholder: "Enter old password",
        new_password: "New Password",
        new_password_placeholder: "Enter new password",
        confirm_password: "Confirm New Password",
        cancel: "Cancel",
        save: "Save",
        yes: "Yes",
        no: "No",
        saving_changes_confirmation: "Are you sure you want to save the changes?",
        update_data_success: "Data updated successfully",
      },
    },
    users: {
      logiplanner: {
        title: "XLplanner",
        add_user: "Add User",
        firstname: "First Name",
        surname: "Last Name",
        function: "Function",
        email: "Email",
        phone: "Phone",
        change_user_data: "Change User Data and Permissions",
        access_blocked: "Access for this user is blocked, click to unblock access",
        delete_user: "Delete User",
        loading: "Loading...",
        status_changed: "Status changed successfully",
        empty_users: "No Users",
        show_docs: "Documents",
        show_workers: "Departments",
        show_gallery: "View Company Gallery",
        add_user_modal: {
          dialog_close: "Close",
          edit_data: "Edit User Data",
          firstname: "First Name",
          firstname_placeholder: "Enter first name",
          email: "Email",
          email_placeholder: "Enter email",
          surname: "Last Name",
          surname_placeholder: "Enter last name",
          phone: "Phone",
          phone_placeholder: "Enter phone",
          cancel: "Cancel",
          save: "Save",
          saving: "Saving...",
        },
      },
    },
  },

  delete_client_modal: {
    dialog_close: "Close",
    deleting_client: "Delete Client",
    deleting_client_confirmation: "Are you sure you want to delete the client",
    cancel: "Cancel",
    delete: "Delete",
    deleting: "Deleting...",
    deleting_success: "Client deleted successfully",
    settings: "Go to Settings",
  },
  months: {
    JAN: "January",
    FEB: "February",
    MAR: "March",
    APR: "April",
    MAY: "May",
    JUN: "June",
    JUL: "July",
    AUG: "August",
    SEP: "September",
    OCT: "October",
    NOV: "November",
    DEC: "December",
  },
  days: {
    MON: "Monday",
    TUE: "Tuesday",
    WEN: "Wednesday",
    THUR: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  },
  generals: generals,
  ratings: ratings,
  widgetsTitles: widgets,
  addings: {
    adding: "Add",
    worker: "Add Employee",
    docs: "Add Documents",
    department: "Add Department",
    warehouse: "Add Warehouse",
    monitary: "Add Notification",
    driver: "Add Carrier",
    job: "Add Order",
    auctions: "My Exchange",
    adding_documents: "Add Documents",
    add_warehouse_menagers: "Additional Employees",
    add_department_menagers: "Additional Employees",
    hint: "Enter order number or company/department name",
    add_attachment: "Add Attachment",
    doc: "Add Document",
    car: "Add Vehicle",
    group: "Add Group",
    show_participants_for: "Show participants for auction:",
    auction: "Add Order",
    add_to_group: "Add to Group",
    driver_person: "Add Driver",
  },
  removings: {
    remove_documnet_question: "Are you sure you want to delete the document?",
    remove_warehouse_question: "Are you sure you want to delete the warehouse?",
    remove_admin_question: "Are you sure you want to delete this admin?",
    remove_worker_question: "Edit Employee",
    block_worker_question: "Are you sure you want to block the employee?",
    unblock_worker_question: "Are you sure you want to unblock the employee?",
  },
  missings: {
    auctions_canceled: "No Canceled Auctions",
    drivers: "No Drivers",
    form: "The form is incorrectly filled out. Fill in the required fields and verify their correctness.",
    departments: "No Departments in Company",
    department_info: "To use the full functionality of the application, you must have at least one department.",
    warehouse_info: "To use the full functionality of the application, you must have at least one warehouse.",
    department_info_worker: "To use the full functionality of the application, you must be assigned to at least one department.",
    warehouse_info_worker: "To use the full functionality of the application, you must be assigned to at least one warehouse.",
    insurances: "Insurance can be added to vehicles, go to the 'My Vehicles' tab and add the first vehicle",
    results: "No results for the specified search categories",
    no_contract: "No Contract Terms",
    no_remarks: "No Additional Information",
    no_car_statuses: "Vehicle statuses will be displayed after adding the first vehicle",
    auction_finished: "The auction is no longer active",
    no_subscription: "You have not purchased a subscription",
    no_cars: "You do not have the appropriate vehicle type",
    notifications: "No Notifications",
    invoices: "No Invoices",
    invoicesMonthly: "No Monthly Invoices",
    groups: "All created groups will be displayed in this list",
    auctions: "No Posted Auctions",
    participants: "No Auction Participants",
    missing_department: "Select the department to which you want to assign the employee.",
    missing_department_driver: "Select the department to which you want to assign the driver.",
    missing_role: "Select the employee role.",
    enter_custom_name: "Enter a custom vehicle name.",
    no_authorized_warehouse:
      "You do not have any authorized warehouses yet. Go to the warehouse list in the Time Windows tab to create the first authorization",
    no_vehicle: "No Vehicles",
    no_vehicle_add: "Add vehicle to perform notification",
    driver: "No drivers in the specified department.",
    limit_reached:
      "Sorry, but the day you selected has reached the limit for notifications. Select another day to complete the notification process.",
    taken_window: "Sorry, but the time window you selected has been taken. Select another time window to complete the notification process.",
  },
  system: {
    system: "System",
    blocked: "Blocked",
    version: "System Version",
    client: "Client Number",
    company_name: "Company Name",
    name_surname: "First and Last Name",
    operating_system: "Operating System",
    browser_version: "Browser Version",
    browser_language: "Browser Language",
    date: "Date",
  },
  car_types: {
    solo_cars: "Solo Vehicle",
    naczepa: "Semi-trailer",
    auta_solowe: "Solo Vehicle",
    dluzyca_przyczepa: "Long Trailer",
    tractor: "Tractor Unit",
    ciagniki_siodlowe: "Tractor Unit",
    tandem: "Tandem",
    solo_car: "Solo Vehicle",
    plain_tractor: "Towing Vehicle",
    furgon: "Van",
    niskopodwoziowy_przyczepa: "Low Bed (Trailer)",
    autolaweta_laweta: "Car Transporter/Trailer",
    wywrotka: "Tipper",
    hakowiec: "Hook Loader",
    walkingfloor: "Walking Floor Tipper",
    custom: "Special Vehicle",
    custom_short: "Special Vehicle",
    bdf_system_przyczepa: "BDF System",
    bdf_system_naczepa: "BDF System",
    izoterma: "Insulated Vehicle",
    cysterna_chemiczna: "Chemical Tanker",
    cysterna_paliwowa: "Fuel Tanker",
    cysterna_gazowa: "Gas Tanker",
    chlodnia: "Refrigerated Vehicle",
    platforma: "Platform",
    przyczepa: "Trailer",
    plandeks_firanka: "Tarpaulin/Curtain",
    plandeka_firanka: "Tarpaulin/Curtain",
    dluzyca: "Long Trailer",
    plandeka_bde: "Tarpaulin BDE",
    plandeka_coilmulde: "Tarpaulin Coilmulde",
    plandeka_joloda: "Tarpaulin Joloda",
    plandeka_jumbo: "Tarpaulin Jumbo",
    plandeka_mega: "Tarpaulin Mega",
    plandeka_standard: "Tarpaulin Standard",
    sztywna_zabudowa: "Fixed Body",
    sztywna_zabudowa_skrzynia: "Fixed Body Box",
    chlodnia_hakowka: "Refrigerated Hook Loader",
    cysterna_inna: "Other Tanker",
    cysterna_silos: "Silo Tanker",
    cysterna_spożywcza: "Food Tanker",
    podkontenerowa_20_cysterna: "Container Trailer 20' Tanker",
    podkontenerowa_40_cysterna: "Container Trailer 40' Tanker",
    podkontenerowa_20_standard: "Container Trailer 20' Standard",
    podkontenerowa_40_standard: "Container Trailer 40' Standard",
    podkontenerowa_45_standard: "Container Trailer 45' Standard",
    podkontenerowa_swapbody: "Container Trailer Swap Body",
    niskopodwoziowy: "Low Bed",
  },
  document_types: {
    all: "All",
    file: "Other",
    nip: "Tax Number",
    regon: "REGON",
    krs_cdig: "Commercial Register",
    transport_license: "(Transport License)",
    carrier_insurance: "(Carrier Insurance)",
    license: "License",
    insurance: "Insurance",
    policy: "Policy",
    agreements: "Contract Terms",
    car_license: "Vehicle Registration",
    worker_license: "Escort License",
  },
  statuses: {
    waiting: "Waiting",
    rejected: "Rejected",
    accepted: "Accepted",
    retreated: "Withdrawn",
    isWaiting: "Waiting",
    accepted_leasings: "Accepted Applications",
    waiting_leasings: "Submitted Applications",
    rejected_leasings: "Rejected Applications",
    multiple_accepted: "Accepted",
    multiple_approved: "Approved",
    all: "All",
    read: "Read",
    unread: "Unread",
    paid: "Paid",
    canceled: "Canceled",
    initialized: "Started",
    all_multiple: "All",
    confirmed: "Confirmed",
  },
  authorizations: {
    no_department: "No Branches",
    no_warehouse: "No Warehouses",
    add_department: "Add Branch",
    add_warehouse: "Add Warehouse",
    cant_authorize_warehouse: "To authorize, you must have at least one warehouse",
    cant_authorize_department: "To authorize, you must have at least one branch",
    cant_monitary_warehouse: "To schedule appointments, you must have at least one warehouse",
    cant_monitary_department: "To schedule appointments, you must have at least one branch",
    pending: "List of Pending Authorizations",
    to_fill_calendar: "To fill the calendar, you must have at least one warehouse",
    all: "List of All Authorizations",
    show_pending: "Show Pending Authorizations",
    show_all: "Show All Authorizations",
    authorization_request_send: "Authorization Request Sent",
    authorization_success: "Successfully Authorized",
    authorization_rejected: "Authorization Rejected",
    authorization_error: "No Authorization",
    authorization_status: "Authorization Status",
    authorized: "Authorized",
    waiting: "Waiting for Confirmation",
    rejected: "Rejected",
    show_authorizations_for: "Show authorizations for",
    show_agreements_for: "Show contract terms for",
    show_statuses_for: "Show vehicle status for",
    pick_department_to_authorization_w: "Select the warehouse you want to authorize with the carrier",
    pick_department_to_authorization_d: "Select the branch you want to authorize with the warehouse",
    show_details: "Show Details",
    retreat: "Are you sure you want to withdraw the authorization?",
    accept: "Are you sure you want to accept the authorization?",
    reject: "Are you sure you want to reject the authorization?",
  },
  auctions: {
    cancled_auctions: "Canceled Orders",
    waiting_auctions: "Assigned Orders",
    listed_auctions: "Posted Orders",
    selected_auctions: "Assigned Orders",
    current_auctions: "Participating Orders",
    my_transactions: "Participating Orders",
    my_auctions: "My Orders",
    all_auctions: "All",
  },
  demand: {
    accept_demand: "Accept Request",
    reject_demand: "Reject Request",
    cancel_demand: "Cancel Request",
    send_demand: "Send Request",
  },
  bank: {
    bank: "Bank",
    loan: "Loan",
    leasing: "Leasing",
    factoring: "Factoring",
  },
  vehicle_alerts: {
    delete_vehicle_question: "Are you sure you want to delete the vehicle?",
    no_vehicles_for_category: "Add vehicles to the respective category, they will be displayed in the corresponding tab.",
  },
  archive: {
    show_archive_for: "Show archive for",
  },
  filters: {
    clear_filters: "Clear Filters",
    search: "Search",
    selected: "selected",
    sort: "Sort by",
    filter_by: "Filter by",
    search_by: "Search by",
    no_sorting: "No Sorting",
    alph_driver: "Alphabetically (by carrier name)",
    alph_warehouse: "Alphabetically (by warehouse name)",
    alph_asc: "Alphabetically A-Z (by name)",
    alph_desc: "Alphabetically Z-A (by name)",
    newest: "Created first",
    oldest: "Created last",
    id_asc: "ID (ascending)",
    id_desc: "ID (descending)",
    id_warehouse_asc: "Warehouse order number (ascending)",
    id_warehouse_desc: "Warehouse order number (descending)",
    radius: "Radius (in kilometers)",
    document_search: "Enter document name",
    car_search: "Enter vehicle name",
    department_search: "Search by name",
    worker_search: "Enter employee's first or last name",
    driver_search: "Enter driver's first or last name",
    leasing_search: "Enter company name or phone number to search for application.",
    auction_search: "Enter tax number, company ID or auction ID to search for auction.",
    chats_search: "Enter branch name to search for chat.",
    chats_search2: "Enter branch name, company tax number or notification number to search for chat.",
    by_department: "Enter branch name, branch email, company name or company tax number.",
    company_search: "Enter tax number, company ID or company name.",
    company_search_detailed: "Enter tax number, ID or name of the company you are looking for",
    user_search: "Enter ID, email, first or last name of the user.",
    invoice: "Enter company name to search for invoice.",
    docs: "Enter company name to search for document.",
    raports: "Enter ID, name or tax number of the branch/company you are looking for.",
    auctions: "Enter ID, name or tax number",
    auctions_detailed: "Enter ID, name, company tax number or auction ID to search for auction",
    show_drivers_for: "Show drivers for",
    auctions_by_id: "Enter auction ID to search for auction",
    auctions_by_id_short: "Enter auction ID",
  },
  languages: {
    pl: "Polish",
    en: "English",
    de: "German",
  },
  widgets: {
    authorization_widget: "Authorization Widgets",
    currency_widget: "Exchange Rate Widget",
    map: "Functionality Map",
    cars: "Vehicle Status",
    error: "Error updating widgets",
    success: "Widgets updated successfully",
    nbp_currencies: "Average Rate of National Bank",
    available: "Available Dashboard Widgets",
    currency: "Exchange Rates",
    monitory: "Notification Calendar",
    functionality_map: "Functionality Map",
    my_cars: "My Vehicles",
    drivers: "Driver List",
    advertisement: "Advertisement",
    user_departments: "My Branches",
    documents: "Documents",
    workers: "Employees",
    company: "Company",
    carrier_groups: "My Groups",
    user_external_warehouses: "External Warehouses",
    user_warehouses: "Warehouse List",
    monitory_notes_archive: "Notification Archive",
    warehouses_list: "My Warehouses",
    authorizations: "Authorizations",
    monitory_notes: "Notifications",
    car_statuses: "Vehicle Status",
    participants_list: "Auction Members",
    auctions_archive: "Auction Archive",
    created_groups: "Created Groups",
    auctions: "Exchange",
    invoices: "Invoices",
    subscription: "Subscription",
    time_windows: "Time Windows",
    leasing: "Leasing",
    factoring: "Factoring",
    surcharges: "Surcharges",
    transports: "Transports",
  },
  phone_verifications: {
    title: "You have an unverified phone number",
    user: "User",
    department: "Branch ",
    company: "Company ",
    enter_code: "Enter code sent to the above phone number",
    code_placeholder: "SMS code",
    resend: "Resend",
    verified: "Phone number verified",
    edited: "Phone number edited",
    wrong_code: "The verification code entered is incorrect",
    wait: "You must wait a moment before we resend the verification code",
    wrong_phone: "Wrong phone number",
  },
  insurences: {
    title: "Insurance",
    date: "Policy Validity",
  },
  monitaryStatuses: {
    accept: "Notification Confirmation",
    finish: "Notification Completed",
    thanks: "Thank you!",
    text1: "Notification ",
    text2: "was successfully confirmed",
    text3: "was successfully completed",
    list: "Show notification list",
  },
  help: {
    title: "Need help?",
    text: "If you have encountered problems using the application or need support with its use, contact us using the following details:",
    phone: "Phone number:",
    email: "Email address:",
  },
  notifications: {
    title: "Notifications",
    created: "created",
    markAsRead: "Mark as read",
    see_all: "See all",
    see_all_noti: "See all notifications",
  },
  leasing: {
    title: "Leasing",
    text1: "Simplified procedure for vehicle and machinery leasing",
    text2: "Automatic decision in 15 minutes - vehicles",
    text3:
      "With an initial down payment for vehicles of 10% - we do not need financial documents, only filling out the application with a business activity over 12 months. For newly established companies, simplified procedure with an initial down payment of 20% of the vehicle value.",
    download: "Download application to fill out",
    no_applications: "No Applications",
    add_application: "Add New Application",
    your_applications: "Your Applications",
    confirm: "Are you sure you want to delete this application?",
    action: "Accept or reject this application",
    info: "We have received your leasing application. We will notify you when it has been processed.",
  },
  chat: {
    show_chats_for: "Show chats for:",
    no_chats: "No active chats",
    no_messages: "No messages",
    go_to_chat: "Go to chat",
    chat_with: "Chat with:",
    chat_for: "Chat for:",
    send: "Send",
    create_chat: "Create new chat",
    create_chat_with: "I want to create a chat with:",
    no_authorized: "No authorized branches to chat with.",
    create: "Create chat",
    goto: "Go to chat",
  },

  unfolded: {
    phone: "Phone",
    created: "Created",
    transaction: "Transaction",
    from: "From",
    to: "To",
    when: "When",
    offers: "Offers",
    lp: "No.",
    id_logi: "XLplanner ID",
    company_name: "Company Name",
    company_address: "Company Address",
    company_owner: "Company Owner",
    details: "Show details",
    doc: "Document",
    name: "Name",
    when_added: "When added",
    action: "Action",
    auction: "Auction",
    status: "Status",
    amount: "Amount",
    no_offers: "No offers in this auction",
  },
  snackbars: {
    offer_added_success: "Auction offer added successfully",
    error_creating_chat: "Error creating chat. Check if a branch was selected.",
    error: "An unexpected error occurred. Please try again.",
    errorEmpty: "The field cannot be empty.",
    invite_success: "Company successfully added to invitation list",
    length_error: "The name field is too long. Maximum length is 30.",
    max_length: "Maximum length is",
    vin: "VIN must be 17 characters long",
    error50: "The field must not exceed 50 characters and cannot be empty.",
    not_found_company: "Tax number not found in GUS database",
    allowSms: "Allow SMS notifications",
    auto_offering: "Choose limit for auto-bidding",
    choose_car: "Choose vehicle",
    no_chats: "No chats",
    no_message: "No message to send",
    nip_wrong: "Tax number not found in GUS database",
    nip_taken: "A company with this tax number already exists in the XLplanner application.",
    no_group: "No group selected.",
    no_departments: "No branches selected.",
    no_department: "No branch selected to which the group should be assigned.",
    pick_group: "Choose target group",
    no_name: "You have not named the group",
    chat_create: "The selected company has no branches with which a chat can be created.",
    no_address: "No address",
    no_companies: "No companies in the specified search categories",
    company_edit_success: "Company edited successfully",
    department_edit: "Edit branch data",
    user_edit: "Edit user data",
    no_results: "No search results",
    delete_package: "Are you sure you want to delete the package?",
    edit: "Edit data",
    no_authorizations:
      "All your authorizations with warehouses will appear in this list. Go to the warehouse list in the Time Windows tab to create the first authorization.",
    no_authorizations_warehouse:
      "All your authorizations with carriers will appear in this list. You will receive a notification when a new request is sent by a carrier.",
    to_add_car: "To add a vehicle, you must first have branches",
    no_offers_in_auction: "No offers in this auction",
    group_created: "Group created successfully.",
    group_empty_error: "You must add at least one existing branch to the group.",
    changes_saved: "Changes saved successfully.",
    chat_redirect_error: "Chat not found",
    permission_error: "No permission",
    permission_detailed: "You cannot manage accounts of other administrators, your own account, or if you are not an administrator yourself.",
  },

  raport: {
    auction_over: "Auction ended",
    action_type: "Action Type",
    date: "Execution Date",
    creator: "Executor",
    creator_short: "Executor",
    about: "Concerns",
    ip: "IP Address and Location",
    details: "Details",
    before: "Before Change",
    after: "After Change",
    types: {
      department_remove_worker: "Employee removed from branch",
      department_add_worker: "Employee added to branch",
      company_remove_worker: "Employee removed from company",
      company_add_worker: "Employee added to company",
      user_data_changed: "User data changed",
      user_data_changed222: "User data changed",
      company_leasing_application_pending: "Leasing application added",
      company_change_status_blocked: "Company blocked",
      company_change_status_activated: "Company authorized",
      company_change_status: "Company status changed",
      change_company_status: "Company status changed",
      leasing_application: "Leasing status changed",
      issue_auction: "Auction added",
      user_change_status_blocked: "Employee blocked",
      user_change_status_activated: "Employee authorized",
      user_change_status_deleted: "Employee deleted",
      admin_add_worker: "XLplanner employee added",
      admin_edit_user_profile: "Admin edited user profile",
      admin_add_payment_price_list_item: "Item added to price list",
      admin_leasing_status_rejected: "Leasing application rejected",
      admin_leasing_status_accepted: "Leasing application accepted",
      admin_edit_department_profile: "Admin edited branch",
      admin_edit_company_profile: "Admin edited company",
      admin_edit_payment_price_list_item: "Price list edited",
      admin_delete_payment_price_list_item: "Item deleted from price list",
      auction_submitting_a_bid: "Offer added to auction",
      company_monitory_note_purchase: "Time window purchased",
      company_subscription_purchase: "Subscription purchased",
      department_send_chat_message: "Message sent in chat",
      company_add_department: "Company added branch",
      company_krs_cdig_document_upload: "Company added commercial register document",
      department_send_chat_message_with_attachment: "Branch sent message with attachment",
      edit_auction: "Auction edited",
    },
    keys: {
      companyId: "Company ID",
      orderNumber: "Order Number",
      currency: "Currency",
      remarks: "Additional Info",
      amount: "Amount",
      status: "Status",
      country: "Country",
      auctionSubId: "Auction ID",
      userDepartment: "Removed Employee",
      user: "Employee",
      auctionId: "Added Auction",
      originalname: "File Name",
      fileId: "Download File",
      subId: "Number",
      email: "Email",
      name: "First Name/Name",
      message: "Message Content",
      surname: "Last Name",
      phone: "Phone",
      userPhone: "Phone",
      phoneNumberVerified: "Phone No. Verified",
      isAccountVerified: "Account Verified",
      allowSms: "Allows SMS Contact",
      price: "Price",
      amountSubscriptionDays: "Number of Subscription Days",
      departmentPhone: "Branch Phone Number",
      address: "Address",
      city: "City",
      zipCode: "Postal Code",
      countryCode: "Country Code",
      contractTerms: "Contract Terms",
      contacTermsHelper: "Add contract terms in PDF file",
      shortName: "Name",
      companyAddresses: "Company Address",
      companyPhone: "Company Phone Number",
      companyNip: "Tax Number",
      companyName: "Name",
      addedUser: "Added Employee",
      isDeleted: "Whether Deleted",
      monitoryNotesNumber: "Number of Time Windows",
    },
    statuses: {
      blocked: "Blocked",
      activated: "Activated",
      deleted: "Deleted",
      pending: "Pending",
      accepted: "Accepted",
      rejected: "Rejected",
      initialized: "Started",
      waiting_for_acceptance: "Waiting",
    },
  },

  change_type_messages: {
    confirm_action: "Confirm Selection",
    change_account_type: "Change Account Type",
    general: "Changing the account will result in the following changes:",
    confirmation_text: "Are you sure you want to change the account type from {0} to {1}?",
    driver_to_warehouse:
      "All carrier branches will be converted to warehouses;Access to wallet will be lost;All authorizations will be deleted;All saved vehicles will be lost;All submitted offers in auctions as well as all assigned orders and the exchange will be canceled;Company and branch data will remain unchanged",
    warehouse_to_driver:
      "All warehouses will be converted to carrier branches;All scheduled and waiting notifications will be canceled;All authorizations will be deleted;Account type cannot be changed if a notification is currently running in any of the warehouses;Company and branch data will remain unchanged",
    driver_to_factory:
      "All carrier branches will be converted to manufacturer branches;Access to wallet will be lost;All authorizations will be deleted;All saved vehicles will be lost;All submitted offers in auctions as well as all assigned orders and the exchange will be canceled;Company and branch data will remain unchanged",
    factory_to_warehouse:
      "All manufacturer branches and warehouses will be converted to warehouses;All authorizations will be deleted;All created exchange transactions as well as orders assigned to carriers will be canceled;Company and branch data will remain unchanged",
    warehouse_to_factory:
      "All warehouses will be converted to carrier warehouses;All scheduled and waiting notifications will be canceled;All authorizations will be deleted;Account type cannot be changed if a notification is currently running in any of the warehouses;Company and branch data will remain unchanged",
    factory_to_driver:
      "All manufacturer branches and warehouses will be converted to carrier branches;All authorizations will be deleted;All created exchange transactions as well as orders assigned to carriers will be canceled;Company and branch data will remain unchanged",
    errors: {
      404: "Company not found",
      403: "You cannot change the account type because there are running notifications on it",
    },
  },
  blocking: {
    title: "Do you want to block the branch?",
    empty: "The branches you have blocked will be displayed here.",
    how: "A branch can be blocked via the branch details screen, which can be accessed for example through authorizations.",
    go_to_list: "Branch List",
    info: "You cannot create notifications with a blocked branch or warehouse. You also will not see auctions created by them. The block list can be edited in settings.",
    choose_department: "Choose your branch",
    choosing: "Choose the branch for which you want to block",
    choosing_unblock: "Choose the branch for which you want to unblock",
    choosing2: "You can select multiple items.",
    list_title: "List of Blocked",
    return: "Restore",
    unblocked: "Branch has been restored",
    unblock_title: "Are you sure you want to restore the branch?",
  },
  factoring: {
    do_you_want: "Do you want factoring?",
    commission: "The commission for factoring is ",
    list: "Factoring Overview",
    search: "Search by auction ID, company, tax number...",
    searchLong: "Enter auction ID, company ID or tax number to search for factoring",
  },
  groups: {
    name: "Group Name",
    members: "Number of Members",
  },
  adverts: {
    add: "Add Advertisement",
    pic: "Advertisement Image",
    link: "Link (optional)",
    save: "Save Advertisement",
    saving: "Saving...",
    deleting: "Are you sure you want to delete the advertisement?",
    pic_error: "You must add at least one image",
  },
  confirmings: {
    driver_came: "Do you really confirm the driver's arrival?",
    driver_absent: "Do you really confirm the driver's absence?",
  },
  calendar_request_modal: {
    title: "Send Calendar Fill Request",
    subtitle: "Choose the form of notification",
    checkbox1: "I want to receive an SMS notification",
    checkbox2: "I want to receive an email notification",
    button: "Send Request",
  },
  role_descriptions: {
    pilot: {
      owner: "Has all permissions (add employees, edit employees, add photos, logo, company documents, add vehicles, submit bids for orders).",
      admin: "Can add documents to company, add employees to assigned branch, add vehicles and submit bids.",
      worker: "Can add vehicles and submit bids for orders.",
    },
    warehouse: {
      owner:
        "Has all permissions (add warehouses, authorize branches, add employees, edit employees, add photos, logo, company documents, create notification calendar, perform notifications, submit leasing applications).",
      admin: "Can add documents to company, add employees to assigned branch, create notification calendar, perform notifications.",
      worker: "Can create notification calendar, perform notifications of assigned branch.",
    },
    driver: {
      owner: "Has all permissions (add employees, edit employees, add photos, logo, company documents, add auctions, create groups)",
      admin: "Can add documents to company, add employees, participate in exchange",
      worker: "Can view company data, participate in exchange",
    },
  },

  info_icons: infoIcons,
  transport_list: {
    list: "Transport List",
    pick_road: "Choose a route section and see details and signatures",
    signatures_word: "Signatures",
    sign: "Sign",
    see: "View",
    sender: "Sender",
    particles: "Part assigned to unloading",
    pallets: "No. of Pallets",
    items: "No. of Items",
    weight: "No. of Tons",
    type: "Type",
    signatures: {
      driver: "Driver Signature",
      sender: "Sender Signature",
      receiver: "Receiver Signature",
    },
  },
  roles: {
    OWNER: "Administrator",
    ADMINISTRATOR: "Manager",
    WORKER: "Employee",
  },
  routes: routes,
  files: {
    errors: {
      size: "File size cannot exceed 10MB",
    },
  },
  reporting: {
    terms: {
      sendSuccess: "Report sent",
      sendError: "Problem sending report occurred",
      send: "Report problem with contract terms",
      enterMessage: "Enter message to report problem with contract terms:",
      sendShort: "Send Report",
    },
  },

  "missing-department-modal": {
    "title-warehouse": "Create Warehouse",
    "title-department": "Create Branch",
    "warehouse-description":
      "Warehouses are the basic element of XLplanner. All important activities in the application are performed by assigning a warehouse to which the planned action should relate. Add the first warehouse to be able to fully use the application.",
    "department-description":
      "Branches are the basic element of XLplanner. All important activities in the application are performed by assigning a branch to which the planned action should relate. Add the first branch to be able to fully use the application.",
  },
  mobile: {
    exchange_orders: "Orders Exchange",
    exchange_pilots: "Pilots Exchange",
  },
};
